module.exports = __webpack_public_path__ + "img/new-project-approval1.09dbc653.png";